import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { RecordLinkService } from './record-link.service';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
  ],
  providers: [
    RecordLinkService
  ],
})
export class RecordLinkModule { }
